import React, { useState, useCallback, useEffect } from 'react';
import { Box, Card, CardActions, CardContent, IconButton, Typography } from '@mui/material';
import { Button, FormGroup, FormControlLabel, InputLabel, Checkbox } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux"
import { imageURL } from "../utils/config";
import { pdpaAPI } from "../services/PdpaAPI"
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import PrintIcon from '@mui/icons-material/Print';
import Swal from "sweetalert2";
import "./pdpa.css"

const PDPA = ({ closeNav, isMobile }) => {
    const dispatch = useDispatch()
    const [check, setCheck] = useState(false)
    const [content, setContent] = useState({})
    const { user: { userData } } = useSelector(state => state)

    useEffect(() => {
        if (userData instanceof Object && userData.pdpa) {
            setCheck(true)
        }
    }, [userData])

    const handleSubmit = useCallback(async () => {
        try {
            if (userData instanceof Object && userData.pdpa) throw { message: "คุณเคยทำ PDPA ไปแล้ว" }
            const { status, message } = await pdpaAPI.submitPDPA()
            if (status == 502) throw { message }
            localStorage.setItem("Token", message)
            Swal.fire({
                icon: 'success',
                confirmButtonColor: "#6ab23a",
                text: `ยินยอมใช้ข้อมูลส่วนบุคคลอ่อนไหวเรียบร้อย`,
                timer: 5000
            }).then(() => {
                dispatch({ type: "USER_UPDATE", payload: { pdpa: true } })
            })
        } catch (error) {
            Swal.fire({
                icon: 'error',
                confirmButtonColor: "#f27474",
                html: `<span class="colorWhite">${error.message}</span>`,
                width: '28rem',
                timer: 3000
            });
        }
    }, [userData])

    useEffect(() => {
        if (userData instanceof Object) {
            pdpaAPI.getCompany()
                .then((res) => {
                    if (res.status != 200) throw { message: res.message }
                    setContent(res.message)
                }).catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${error.message}</span>`,
                        width: '28rem',
                        timer: 3000
                    });
                })
        }
        return () => {
            setContent({})
        }
    }, [userData])

    const clearText = useCallback((text) => {
        let newText = text.replace(/\D/g, "")
        return newText
    }, [userData])

    return (
        <>
            <div className='container h-100vh' style={{ marginTop: '10%', display: closeNav ? 'flex' : isMobile ? 'none' : 'flex', marginTop: !isMobile ? 0 : '70px', justifyContent: 'flex-start', padding: '0' }}>
                <Card
                    sx={{
                        overflowY: 'auto',
                        minWidth: 275,
                        marginLeft: { xs: 0, sm: '5%' },
                        marginRight: { xs: 0, sm: '5%' },

                    }} style={{ boxShadow: 'none' }} >
                    <CardActions
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' }
                        }}
                        style={{ opacity: '50%', borderBottomStyle: 'solid', borderBottomColor: content.color || '#5BB846', justifyContent: 'space-between' }}>
                        <img src={`${imageURL}/icons/${content.logo}`} alt="" style={{ width: '164px' }} />
                        <Box style={{ marginLeft: 0 }}>
                            <Typography variant="body2" style={{ textTransform: 'uppercase', fontSize: '18px', fontWeight: 700, textAlign: 'left', width: '-webkit-fill-available' }}>
                                {content.name_en}
                            </Typography>
                            <Typography variant="body2" style={{ fontSize: '12px', fontWeight: 700, textAlign: 'left', width: '-webkit-fill-available' }}>
                                {content.address_en1}<br /> {content.address_en2}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                marginTop: { xs: '16px', sm: 0 },
                                marginBottom: { xs: '8px', sm: 0 },
                            }}
                            style={{ marginLeft: 0, borderLeftStyle: 'solid', borderLeftColor: content.color || '#5BB846', paddingLeft: '16px', gap: '8px', display: 'flex', flexDirection: 'column' }}>
                            <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <IconButton style={{ width: '24px', height: '24px', backgroundColor: content.color || '#5BB846' }}>
                                    <LocalPhoneIcon style={{ width: '16px', height: '16px', color: 'white' }} />
                                </IconButton>
                                <Typography variant="body2" style={{ fontSize: '12px', fontWeight: 700, textAlign: 'left', width: '-webkit-fill-available', marginLeft: 0, }}>
                                    TEL {content.tel || "-"}
                                </Typography>
                            </Box>
                            <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <IconButton style={{ width: '24px', height: '24px', backgroundColor: content.color || '#5BB846' }}>
                                    <PrintIcon style={{ width: '16px', height: '16px', color: 'white' }} />
                                </IconButton>
                                <Typography variant="body2" style={{ fontSize: '12px', fontWeight: 700, textAlign: 'left', width: '-webkit-fill-available', marginLeft: 0, }}>
                                    FAX  {content.fax || "-"}
                                </Typography>
                            </Box>
                            <Typography variant="body2" style={{ fontSize: '12px', fontWeight: 700, textAlign: 'left', width: '-webkit-fill-available', marginLeft: 0 }}>
                                CALL CENTER {content.callcenter || "-"}
                            </Typography>
                        </Box>
                    </CardActions>
                    <CardContent style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '8px', textAlign: 'center' }}>
                            แบบฟอร์มการขอความยินยอมใช้ข้อมูลส่วนบุคคลอ่อนไหว
                            <br />
                            ชื่อบริษัท {content.name_th}
                        </Typography>
                        <Typography variant="body2" style={{ textIndent: '3.125rem', textAlign: 'left' }}>
                            เพื่อประโยชน์ในการคุ้มครองแรงงาน ภายใต้สัญญาจ้างแรงงาน บริษัทจำเป็นต้องเก็บ รวบรวม และใช้ข้อมูลส่วนบุคคลอ่อนไหวตามนิยามที่ระบุไว้ในกฎหมายที่เกี่ยวข้องของพนักงาน ทั้งนี้ บริษัทรับประกันการประมวลผลข้อมูลส่วนบุคคลอ่อนไหว ตามเงื่อนไขนโยบายข้อมูลส่วนบุคคลสำหรับพนักงานที่บริษัทได้ประกาศไว้
                        </Typography>
                        <Box style={{ textAlign: 'left' }} className="copy">
                            <Box display="flex">ข้าพเจ้า<span className='dottext' style={{ width: 300, maxWidth: 300 }}>{userData.fullname}</span >เลขที่พนักงาน<span className='dottext' style={{ width: 200, maxWidth: 200 }}>{clearText(userData.username)}</span></Box>
                        </Box>
                        <Typography variant="body2" style={{ textAlign: 'left' }}>
                            [ {check ? "✔" : " "} ] ยินยอมให้บริษัทเก็บ รวบรวม ใช้ และ/หรือส่งต่อเปิดเผยข้อมูลสุขภาพ ทั้งในลักษณะของผลการตรวจสุขภาพ การสุ่มตรวจสุขภาพและสารเสพติด หรือข้อมูลที่อาจได้รับจากการเบิกค่ารักษาพยาบาล หรือ การลาป่วยของข้าพเจ้า เพื่อ
                        </Typography>
                        <Typography variant="body2" style={{ textAlign: 'left', paddingLeft: '3.125rem' }}>
                            (1) การประเมินคุณสมบัติและความเหมาะสมในการปฏิบัติงานของข้าพเจ้า <br />
                            (2) การให้สวัสดิการตรวจสุขภาพประจำปี การบริหารจัดการประกันกลุ่มหรือประกันสุขภาพ และ/หรือการให้สวัสดิการอื่น ให้แก่ข้าพเจ้า ภายใต้สวัสดิการสัญญาจ้างแรงงาน หรือ <br />
                            (3) เพื่อการบริหารจัดการอาชีวอนามัยโดยรวมของสถานที่ทำงาน ภายใต้กรอบกำหนดที่เหมาะสม
                        </Typography>
                        <Typography variant="body2" style={{ textAlign: 'left' }}>
                            [ {check ? "✔" : " "} ] ยินยอมให้บริษัทเก็บ รวบรวม ใช้ข้อมูลประวัติอาชญากรรมของข้าพเจ้า เพื่อการประเมินคุณสมบัติ และความเหมาะสมในการปฏิบัติงานของข้าพเจ้าตลอดระยะเวลาการจ้างงาน ภายใต้สัญญาจ้างแรงงาน และเก็บข้อมูลประวัติอาชญากรรมดังกล่าวเพื่อการบังคับโทษวินัย หรือการใช้สิทธิเรียกร้องภายใต้กฎหมายของบริษัท
                        </Typography>
                        <Typography variant="body2" style={{ textAlign: 'left' }}>
                            [ {check ? "✔" : " "} ] ข้าพเจ้ายินยอมให้บริษัทเก็บ รวบรวม ใช้ลายนิ้วมือ และ/หรือแบบจำลองใบหน้าของข้าพเจ้า เพื่อประโยชน์ในการควบคุมสิทธิการเข้าถึงพื้นที่ทำงาน และคุ้มครองรักษาความมั่นคงปลอดภัยของระบบการทำงาน ซึ่งถือเป็นเงื่อนไขสำคัญในการปฏิบัติหน้าที่ของข้าพเจ้า ภายใต้สัญญาจ้างแรงงาน
                        </Typography>

                        <Typography variant="body2" style={{ fontWeight: 'bold', marginTop: '16px', marginBottom: '8px', textAlign: 'center' }}>
                            Employee’s Consent for Processing of the Sensitive Personal Data
                            <br />Company name {content.name_en}
                        </Typography>
                        <Typography variant="body2" style={{ textAlign: 'left' }}>
                            For the labor protection purpose under the employment agreement, the Company is necessary to collect, compile and use the sensitive personal data, as defined by applicable laws, of the employee. The Company undertakes to process such sensitive personal data in compliance with the conditions as stipulated in the Employee Privacy Policy that has been announced by the Company.
                        </Typography>
                        <Box style={{ textAlign: 'left' }} className="copy">
                            <Box display="flex">I<span className='dottext' style={{ width: 300, maxWidth: 300 }}>{userData.fullname_eng}</span >Employee’s Number<span className='dottext' style={{ width: 200, maxWidth: 200 }}>{clearText(userData.username)}</span></Box>
                        </Box>
                        <Typography variant="body2" style={{ textAlign: 'left' }}>
                            [ {check ? "✔" : " "} ] consent to the Company to collect, compile, use and/or disclose my health information, in the form of annual health checkup results, random health and drug screening, or information obtained from medical disbursements, or sick leave information for the purposes of
                        </Typography>
                        <Typography variant="body2" style={{ textAlign: 'left', paddingLeft: '3.125rem' }}>
                            (1) assessing my qualifications and suitability for work,  <br />
                            (2) providing annual health checkup benefits,managing of group insurance or health insurance and/or any other benefits which I am entitled under the employment agreement, or  <br />
                            (3) managing of the overall occupational health in the workplace with an appropriate framework.
                        </Typography>
                        <Typography variant="body2" style={{ textAlign: 'left' }}>
                            [ {check ? "✔" : " "} ] consent to the Company to collect, compile, use my criminal record for my qualifications and suitability for work throughout the employment period under the employment agreement, including collecting such criminal record for the Company’s disciplinary enforcement or claims exercising purposes.
                        </Typography>
                        <Typography variant="body2" style={{ textAlign: 'left' }}>
                            [ {check ? "✔" : " "}] consent to the Company to collect, compile, use my fingerprint information and/or facial recognition for the purpose of controlling the access in the workplace and ensuring security protection on the workplace, which is an important condition of performing my duties under the employment agreement.
                        </Typography>
                    </CardContent>
                    <CardActions style={{ flexDirection: 'column', alignItems: 'start', opacity: '50%' }}>
                        <Typography variant="body2" style={{ fontWeight: 700, textTransform: 'uppercase', textAlign: 'right', width: '-webkit-fill-available', borderBottomStyle: 'solid', borderBottomColor: content.color || '#5BB846' }}>
                            {content.name_en2 || content.name_en}
                        </Typography>
                        <Box style={{ display: 'flex', justifyContent: 'space-between', width: '-webkit-fill-available' }}>
                            <Typography variant="body2" style={{ textAlign: 'left', margin: 0, fontWeight: 700 }}>
                                {content.name_th}
                            </Typography>
                            <Typography variant="body2" style={{ textAlign: 'left', margin: 0, fontWeight: 700 }}>
                                : {content.web}
                            </Typography>
                        </Box>
                        <Typography variant="body2" style={{ textAlign: 'left', margin: 0, fontWeight: 700, color: content.color || '#5BB846' }}>
                            {content.address_th}
                        </Typography>
                    </CardActions>
                    <CardActions style={{ flexDirection: 'column', alignItems: 'center', margin: 'auto' }}>
                        <FormGroup className={`group-mt_1`} style={{ marginTop: 5 }}>
                            <InputLabel >
                                <strong>ยินยอมให้ใช้ข้อมูลส่วนบุคคลอ่อนไหว</strong>
                            </InputLabel>
                            <FormControlLabel control={<Checkbox disabled={userData?.pdpa} checked={check} onClick={() => { setCheck((old) => !old) }} />} label="ใช่" />
                        </FormGroup>
                        <Button
                            onClick={handleSubmit}
                            disabled={!check || userData?.pdpa}
                            variant="contained"
                            style={{
                                textTransform: 'none', backgroundColor: (!check || userData?.pdpa) ? "lightgray" : "#6ab23a", color: 'white', cursor: 'pointer', marginTop: 5
                            }}
                        >
                            บันทึก
                        </Button>
                    </CardActions>
                </Card>
            </div></>)
}

export default PDPA